module.exports = __webpack_public_path__ + "img/silhouette-star.98d673e4.png";